import { BookBookmark } from '@pzh-ui/icons'

import {
    useWettelijkeTaakAtemporalCreateObject,
    useWettelijkeTaakAtemporalDeleteObject,
    useWettelijkeTaakAtemporalEditObject,
    useWettelijkeTaakGetRelationsList,
    useWettelijkeTaakListValidLineages,
    useWettelijkeTaakPostRelationsOverwrite,
    useWettelijkeTaakViewObjectLatest,
} from '@/api/fetchers'
import { generateDynamicSchema } from '@/validation/dynamicObject'
import { schemaDefaults } from '@/validation/zodSchema'

import { DynamicObject } from './types'

const fetchers = {
    useGetValid: useWettelijkeTaakListValidLineages,
    useGetValidLineage: null,
    useGetVersion: null,
    useGetLatestLineage: useWettelijkeTaakViewObjectLatest,
    useGetRevision: null,
    useGetRelations: useWettelijkeTaakGetRelationsList,
    usePutRelations: useWettelijkeTaakPostRelationsOverwrite,
    useGetLatestLineageInModule: null,
    usePatchObjectInModule: null,
    usePatchObject: useWettelijkeTaakAtemporalEditObject,
    useDeleteObject: useWettelijkeTaakAtemporalDeleteObject,
    useGetStatic: null,
    usePostStatic: null,
    useGetAcknowledgedRelations: null,
    usePostAcknowledgedRelations: null,
    usePatchAcknowledgedRelations: null,
    usePostObject: useWettelijkeTaakAtemporalCreateObject,
    useGetActiveModules: null,
}

const wettelijkeTaak: DynamicObject<typeof fetchers> = {
    defaults: {
        singular: 'wettelijke_taak',
        singularReadable: 'wettelijke taak',
        singularCapitalize: 'Wettelijke taak',
        plural: 'wettelijke-taken',
        pluralReadable: 'wettelijke taken',
        pluralCapitalize: 'Wettelijke taken',
        prefixSingular: 'de',
        prefixPlural: 'de',
        prefixNewObject: 'Nieuwe',
        demonstrative: 'deze',
        atemporal: true,
        icon: BookBookmark,
    },
    fetchers,
    dynamicSections: [
        {
            fields: [
                {
                    name: 'Title',
                    label: 'Titel',
                    description:
                        'Formuleer in enkele woorden de titel van de wettelijke taak.',
                    placeholder: "Bijv. 'Actieplan geluid'",
                    type: 'text',
                    required: true,
                    validation: schemaDefaults.title,
                },
                {
                    name: 'Weblink',
                    label: 'Link naar wetten.nl',
                    type: 'url',
                    // @ts-ignore
                    validation: schemaDefaults.optionalUrl,
                },
            ],
        },
    ],
}

wettelijkeTaak.validationSchema = generateDynamicSchema(
    wettelijkeTaak.dynamicSections
)

export default wettelijkeTaak
